export default "__VITE_ASSET__Btkpv8LQ__"